<template>
  <nav>
    <v-navigation-drawer v-model="drawer" disable-resize-watcher app>
      <v-list dense>
        <v-list-group v-for="itemMenu in menu" :key="itemMenu.descricao">
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>dynamic_feed</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="itemMenu.descricao"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="itemSubMenu in itemMenu.menu"
            :key="itemSubMenu.descricao"
            :to="itemSubMenu.path"
          >
            <v-list-item-action>
              <AlertIcon v-if="itemSubMenu.path === '/listadeboletos'"/>
              <v-icon v-else >mdi-chevron-double-right</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ itemSubMenu.descricao }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      flat
      absolute
      :color="colorMenu"
      :class="{ 'larger-menu': desktopBreakpoint }"
      :height="!desktopBreakpoint ? '97px' : ''"
    >
      <v-container class="py-0 fill-height">
        <v-app-bar-nav-icon
          class="onPrimaryHighEmphasis--text"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>

        <v-toolbar-title>
          <span class="surface--text text-h6">
            {{ pageName }}
          </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="onPrimaryHighEmphasis"
              @click="logout()"
              v-on="on"
            >
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </v-container>
    </v-app-bar>
  </nav>
</template>

<script>
import { mapActions } from 'vuex';
import AlertIcon from '@/components/template/alert/AlertIcon.vue';
import { isAdmProfile } from '@/utils/auth';

export default {
  components:{
    AlertIcon
  },
  data: () => ({
    colorMenu:'primary',
    drawer: true,
    isAdmProfile,
    isAdministrador: true,
    user: 'Foo', //pegar do vuex
    menu: [],
  }),
  computed: {
    pageName() {
      return this.$route.name;
    },
    desktopBreakpoint() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  created: function() {
    var usrAdm = this.isAdmProfile();
    if (!usrAdm) {
      this.menu.push(
        {
          descricao: 'Principal',
          menu: [
          {
              descricao: 'Cadastro de Pessoas',
              path: '/cadastrodepessoas'
            },
            {
              descricao: 'Cadastro de Unidades',
              path: '/cadastrodeobras'
            },
            {
              descricao: 'Cadastro de Empresas',
              path: '/cadastrodeempresas'
            },
            {
              descricao: 'Cadastro de Entrada',
              path: '/entrada'
            },
            {
              descricao: 'Cadastro de Saida',
              path: '/saida'
            },
            {
              descricao: 'Controle de Contas a pagar',
              path: '/cadastrodeboleto'
            },
            {
              descricao: 'Controle de Valores a receber',
              path: '/cadastrodevalores'
            },
            {
              descricao: 'Controle de Equipamento',
              path: '/materiais'
            },
          ]
        });
    }else{
      this.menu.push({
          descricao: 'Movimentação',
          menu: [
            {
              descricao: 'Cadastro de Pessoas',
              path: '/cadastrodepessoas'
            },
            {
              descricao: 'Cadastro de Obras',
              path: '/cadastrodeobras'
            },
            {
              descricao: 'Cadastro de Empresas',
              path: '/cadastrodeempresas'
            },
            {
              descricao: 'Cadastro de Entrada',
              path: '/entrada'
            },
            {
              descricao: 'Cadastro de Saida',
              path: '/saida'
            },
            {
              descricao: 'Balanço financeiro',
              path: '/balanco'
            },
            {
              descricao: 'Controle de Contas a pagar',
              path: '/cadastrodeboleto'
            },
            {
              descricao: 'Controle de Valores a receber',
              path: '/cadastrodevalores'
            },
            {
              descricao: 'Controle de Equipamento',
              path: '/materiais'
            },
          ],
        });
    }
  },
  methods: {
    ...mapActions('main', ['handleLogOut','setAuthenticated']),
    logout(){
      this.setAuthenticated(true);
      this.setAuthenticated(false);
      localStorage.setItem('token_sistema', null);
      localStorage.removeItem('autenticado_sistema', false);
      this.handleLogOut();
       this.$vuetify.theme.themes.light.primary = '#0030b1'
    },
  },
};
</script>

<style scoped>
.larger-menu {
  height: 200px !important;
  z-index: 0 !important;
}
</style>
